/**
 * B4: Goal Node Component — Sprint 17 enhanced with Lucide + CSS vars
 */
import { useTranslation } from "@/i18n";
import { cn } from "@/lib/utils";
import { Target } from "lucide-react";
import type { GoalNodeData } from "./types";

interface GoalNodeProps {
  node: GoalNodeData;
  isSelected: boolean;
  onSelect: (id: string) => void;
}

export function GoalNode({ node, isSelected, onSelect }: GoalNodeProps) {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      onClick={() => onSelect(node.id)}
      className={cn(
        "flex items-center gap-2 rounded-lg border-2 px-4 py-3 text-left shadow-sm transition-colors",
        "bg-[var(--color-success)]/5 border-[var(--color-success)]/20 hover:border-[var(--color-success)]/50",
        isSelected && "ring-2 ring-[var(--color-success)] border-[var(--color-success)]/80",
      )}
    >
      <Target className="h-5 w-5 text-[var(--color-success)]" />
      <div>
        <div className="text-xs font-medium text-[var(--color-success)] uppercase">
          {t("journey.node.goal")}
        </div>
        <div className="text-sm font-medium text-[var(--color-foreground)]">
          {t(`journey.goal.${node.eventType}`)}
        </div>
        <div className="text-xs text-[var(--color-muted-foreground)]">
          {node.conversionWindowDays}d {t("journey.goal.window")}
        </div>
      </div>
    </button>
  );
}
